import React from "react";


interface QuestionIconProps {
    className?: string
} 

export default function QuestionIcon(props: QuestionIconProps): JSX.Element {
    return (
        <img className={props.className} src="./images/Amp-q-mark.png" alt=""></img>
    )
}